// extracted by mini-css-extract-plugin
export default {"wrapper":"AerWear_wrapper__AQDm7","articleWrapper":"AerWear_articleWrapper__zNjqG"};